import { render, staticRenderFns } from "./titleBlock.vue?vue&type=template&id=f2709fa0&scoped=true&"
import script from "./titleBlock.vue?vue&type=script&lang=js&"
export * from "./titleBlock.vue?vue&type=script&lang=js&"
import style0 from "./titleBlock.vue?vue&type=style&index=0&id=f2709fa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2709fa0",
  null
  
)

export default component.exports